<template>
  <div class="d-flex flex-row">
    <!-- Display Selected Code -->
    <div
      :class="[
        inputFieldClass
          ? 'style-country-code-shadow-container'
          : 'style-country-code-container',
        'me-2 py-2 px-2',
        disabled ? 'style-disabled' : '',
      ]"
      :data-bs-toggle="disabled ? '' : 'modal'"
      :data-bs-target="disabled ? '' : '#countryCode'"
    >
      <div :class="'d-flex flex-row style-selected-item'">
        <span class="ms-1">+ {{ countryCode }}</span>
        <i class="bi bi-caret-down-fill ms-auto style-down-icon"></i>
      </div>
    </div>

    <!-- Modal for Country Code Selection -->
    <div
      class="modal fade"
      id="countryCode"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content style-scroll">
          <country-code-picker
            v-model:selectedCountryCode="selectedCountryCode"
          />
        </div>
      </div>
    </div>

    <!-- Input Phone Number -->
    <input
      :class="[
        errorValidate ? 'style-error-message' : '',
        inputFieldClass ? inputFieldClass : 'style-input-field',
        'form-control',
      ]"
      type="number"
      placeholder="Phone Number"
      @keydown="
        (event) =>
          ['e', 'E', '+', '-', '.'].includes(event.key) &&
          event.preventDefault()
      "
      :value="phoneNumber"
      :disabled="disabled"
      @input="$emit('update:phoneNumber', $event.target.value)"
    />
  </div>

  <div class="text-danger text-start" v-if="errorValidate">
    <span>{{ errorValidate }}</span>
  </div>
</template>

<script>
import { countries } from "@/common/constant/Countries.js";
import CountryCodePicker from "./CountryCodePicker.vue";

export default {
  name: "PhoneInputField",
  components: { CountryCodePicker },
  emits: ["countryCode", "update:phoneNumber"],
  props: {
    phoneNumber: String,
    errorValidate: String,
    inputFieldClass: {
      type: String,
      default: null,
    },
    defaultCountryCode: {
      type: String,
      default: "65",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatCountryCode(countryCode, phoneCode) {
      return `${countryCode} (+${phoneCode})`;
    },
  },
  data() {
    return {
      countries,
      countryCode: null,
    };
  },
  computed: {
    selectedCountryCode: {
      set(value) {
        this.countryCode = value;
        this.$emit("countryCode", value);
      },
      get() {
        return this.countryCode;
      },
    },
  },
  created() {
    // set default country code
    this.countryCode = this.defaultCountryCode;
  },
  watch: {
    defaultCountryCode(value) {
      this.countryCode = value;
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 250px) {
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog {
    max-width: 350px;

    margin: 1.75rem auto;
  }
}

.modal-content {
  overflow: hidden;
}

.style-input-field {
  height: 50px;
  border: 1px solid #adadad;
  font-weight: 100;
}
.style-input-field:focus {
  border-color: #4a4a4a;
}
.style-error-message {
  border: 1px solid $error-color;
}
.style-error-message:focus {
  border-color: $error-color;
}

.style-scroll {
  height: 80vh;
  overflow: scroll;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.style-scroll::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.style-scroll {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.style-input-field:focus,
select:focus {
  /* outline: none; */
  border-color: #4a4a4a;
  box-shadow: none;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.style-country-code-container {
  border: 1px solid #adadad;
  cursor: pointer;
  height: 50px;
  width: 110px;
  border-radius: 6px;
}

.style-country-code-shadow-container {
  padding: 10px 15px 10px 15px;
  width: 110px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
}

.style-selected-item {
  font-size: $large-font-size;
  padding-top: 3px;
}

.style-down-icon {
  font-size: 14px;
}

.style-disabled {
  background-color: #e9ecef;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
